export default "__VITE_ASSET__f391abb1__"